import React from 'react'
import { Checkbox, Form } from 'antd'
import PropTypes from 'prop-types'

import { antFormItemNamePropType } from '../../prop-types'

const FormCheckbox = ({ name, label, rules, disabled }) => (
  <Form.Item name={name} valuePropName="checked" rules={rules}>
    <Checkbox disabled={disabled}>{label}</Checkbox>
  </Form.Item>
)

FormCheckbox.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  disabled: PropTypes.bool,
}

FormCheckbox.defaultProps = {
  label: '',
  rules: undefined,
  disabled: false,
}

export default FormCheckbox
